export class MobileMap {
  constructor() {
    this._maps = document.querySelectorAll(".s-dynamic-map__map--item");
    this._filter = document.querySelectorAll(".c-mobile-map--item");

    if (this._maps.length) {
      this.start();
    }

  }

  start() {
    this._filter.forEach((item) => {
      item.addEventListener("click", () => {
        this._filter.forEach((item) => {
          item.classList.remove("active");
        })

        this._maps.forEach((map) => {
          map.classList.remove("active");
        })

        let data = item.getAttribute("data-map");
        item.classList.add("active");

        switch (data) {
          case "Métropole":
            document.querySelector('.s-dynamic-map__map--main').parentNode.classList.add("active");
            break;
          case "Île-de-France":
            document.querySelector('.s-dynamic-map__map--paris').parentNode.classList.add("active");
            break;
          case "Dom Tom":
            document.querySelector('.s-dynamic-map__map--dom').parentNode.classList.add("active");
            break;
        }
      })
    })
  }
}

